jQuery(function ($) {
	const Scripts = {
    header() {
      //! Open mobile Menu
      let bodyLockStatus = true

      let bodyLockToggle = (delay = 500) => {
        if (document.documentElement.classList.contains('lock')) {
          bodyUnlock(delay)
        } else {
          bodyLock(delay)
        }
      }
      let bodyUnlock = (delay = 500) => {
        if (bodyLockStatus) {
          const lockPaddingElements = document.querySelectorAll("[data-lp]");
          setTimeout(() => {
            lockPaddingElements.forEach(lockPaddingElement => {
              lockPaddingElement.style.paddingRight = ''
            });
            document.body.style.paddingRight = ''
            document.documentElement.classList.remove("lock")
          }, delay)
          bodyLockStatus = false
          setTimeout(function () {
            bodyLockStatus = true
          }, delay)
        }
      }
      let bodyLock = (delay = 500) => {
        if (bodyLockStatus) {
          const lockPaddingElements = document.querySelectorAll("[data-lp]")
          const lockPaddingValue = window.innerWidth - document.body.offsetWidth + 'px'
          lockPaddingElements.forEach(lockPaddingElement => {
            lockPaddingElement.style.paddingRight = lockPaddingValue
          });

          document.body.style.paddingRight = lockPaddingValue
          document.documentElement.classList.add("lock")

          bodyLockStatus = false
          setTimeout(function () {
            bodyLockStatus = true
          }, delay)
        }
      }

      (function menuInit() {
        if (document.querySelector(".icon-menu")) {
          document.addEventListener("click", function (e) {
            const htmlEl = document.documentElement;

            if (bodyLockStatus && e.target.closest('.icon-menu')) {
              if (htmlEl.classList.contains('search-open')) {
                htmlEl.classList.remove('search-open', 'lock')
              }
              bodyLockToggle();
              htmlEl.classList.toggle("menu-open");
            }

            if (e.target == document.querySelector('body') && htmlEl.classList.contains('menu-open')) {
              bodyUnlock();
              document.documentElement.classList.remove("menu-open");
            }
          });
        };
      })()

      //! Dropdown Menu
      const subMenu = document.querySelectorAll('.menu-item-has-children > a');

      function initSubMenu() {
        subMenu.forEach(el => el.addEventListener('click', openSubMenu));
      };

      function closeSubMenu() {
        subMenu.forEach(element => {
          element.classList.remove('openned');
        });
      }

      function openSubMenu(e) {
        const target = e.target.parentElement;

        const isOpenned = target.classList.contains('openned');
        const listHeight = target.querySelector('.sub-menu')?.clientHeight;

        if (!isOpenned && target.classList.contains('menu-item-has-children')) { // if closed
          closeSubMenu();

          target.style.setProperty('--submenu-height', `${listHeight + 40}px`);
          target.classList.add('openned');
        
        } else if (isOpenned) { // if opened
          target.style.setProperty('--submenu-height', `0px`);
          target.classList.remove('openned');
        }
      }

      function handleResize() {
        if (document.body.clientWidth < 1314 && subMenu) {
          initSubMenu();
        } else {
          subMenu.forEach(el => el.removeEventListener('click', openSubMenu));
          closeSubMenu(); // Close all submenus on resize when width is greater than 1314px
        }
      }

      // Initialize on load
      handleResize();

      // Initialize on resize
      window.addEventListener('resize', handleResize);

      //! Dropdown Menu
      // const subMenu = document.querySelectorAll('.menu-item-has-children > a');

      // function initSubMenu() {
      //   subMenu.forEach(el => el.addEventListener('click', openSubMenu));
      // };

      // function closeSubMenu() {
      //   subMenu.forEach(element => {
      //     element.classList.remove('openned');
      //   });
      // }

      // function openSubMenu(e) {
      //   console.log('SubMenu clicked', e.target);
      //   const target = e.target.parentElement;

      //   const isOpenned = target.classList.contains('openned');
      //   const listHeight = target.querySelector('.sub-menu')?.clientHeight;

      //   if (!isOpenned && target.classList.contains('menu-item-has-children')) { // if closed
      //     closeSubMenu();

      //     target.style.setProperty('--submenu-height', `${listHeight + 40}px`);
      //     target.classList.add('openned');
        
      //   } else if (isOpenned) { // if openned

      //     target.style.setProperty('--submenu-height', `0px`);
      //     target.classList.remove('openned');
      //   }
      // }

      // if (document.body.clientWidth < 1314 && subMenu) {
      //   initSubMenu();
      // }
      // Scrolled header
      const header = document.querySelector('header');

      window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      });
		},

    home() {
      $(document).on('click', '.usefull-links__item', function () {
        let href = $(this).attr('href');

        if (href == '#urbot') {
          $('._8F16FLpNYfUVb73YgW64H').trigger('click');

          return false;
        }
      });
    },

    search() {
      //! Search posts
      const searchForms = document.querySelectorAll('.search-form');

      searchForms.length && searchForms.forEach(searchForm => {
        const searchInput = searchForm.querySelector('input');
        const searchCancel = searchForm.querySelector('span');
  
        const showCrossIcon = () => {
          searchCancel.classList.toggle('visible', searchInput.value.length > 0);
        };
      
        searchInput.addEventListener('input', showCrossIcon);
      
        searchCancel.addEventListener('mousedown', (e) => {
          e.preventDefault();
          searchInput.value = '';
          searchInput.focus();
          showCrossIcon();
        });
      });

      const searchBtn = document.querySelector('.search-btn');
      const documentEl = document.documentElement;
      let isOpened;

      const toggleSearchState = () => {
        isOpened = documentEl.classList.contains('search-open');

        if (isOpened) {
          documentEl.classList.remove('search-open', 'lock');
        } else {
          documentEl.classList.remove('menu-open');
          documentEl.classList.add('search-open', 'lock');

          document.querySelector('.header__search input').focus();
        }
      };

      searchBtn.addEventListener('click', toggleSearchState);
      
      // Close by overlay
      document.addEventListener('click', (e) => {
        const bodyEl = document.querySelector('body');

        if (bodyEl == e.target) {
          if (documentEl.classList.contains('search-open')) {
            documentEl.classList.remove('search-open', 'lock')
          }
          if (documentEl.classList.contains('menu-open') ) {
            documentEl.classList.remove('menu-open', 'lock');
          }
        }
      });


      
      // const searchForm = document.querySelector('.search-form');
      // const searchInput = searchForm.querySelector('input');
      // const searchCancel = searchForm.querySelector('span');

      // const searchBtn = document.querySelector('.search-btn');
      // const documentEl = document.documentElement;
      // let isOpened = documentEl.classList.contains('search-open');

      // const toggleSearchState = () => {

      //   if (isOpened) {
      //     documentEl.classList.remove('search-open', 'lock');
      //   } else {
      //     documentEl.classList.remove('menu-open');
      //     documentEl.classList.add('search-open', 'lock');
      //     searchInput.focus();
      //   }
      // };
    
      // const showCrossIcon = () => {
      //   searchCancel.classList.toggle('visible', searchInput.value.length > 0);
      // };
    
      // searchInput.addEventListener('input', showCrossIcon);
    
      // searchCancel.addEventListener('mousedown', (e) => {
      //   e.preventDefault();
      //   searchInput.value = '';
      //   searchInput.focus();
      //   showCrossIcon();
      // });
    
      // searchBtn.addEventListener('click', toggleSearchState);
      
      // document.addEventListener('click', (e) => {
      //   const bodyEl = document.querySelector('body');

      //   if (bodyEl == e.target) {
      //     if (documentEl.classList.contains('search-open')) {
      //       documentEl.classList.remove('search-open', 'lock')
      //     }
      //     if (documentEl.classList.contains('menu-open') ) {
      //       documentEl.classList.remove('menu-open', 'lock');
      //     }
      //   }
      // });
    },

    spollers() {
      let _slideUp = (target, duration = 500, showmore = 0) => {
        if (!target.classList.contains('_slide')) {
          target.classList.add('_slide');
          target.style.transitionProperty = 'height, margin, padding';
          target.style.transitionDuration = duration + 'ms';
          target.style.height = `${target.offsetHeight}px`;
          target.offsetHeight;
          target.style.overflow = 'hidden';
          target.style.height = showmore ? `${showmore}px` : `0px`;
          target.style.paddingTop = 0;
          target.style.paddingBottom = 0;
          target.style.marginTop = 0;
          target.style.marginBottom = 0;
          window.setTimeout(() => {
            target.hidden = !showmore ? true : false;
            !showmore ? target.style.removeProperty('height') : null;
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            !showmore ? target.style.removeProperty('overflow') : null;
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            target.classList.remove('_slide');
            // Створюємо подію 
            document.dispatchEvent(new CustomEvent("slideUpDone", {
              detail: {
                target: target
              }
            }));
          }, duration);
        }
      }
      let _slideDown = (target, duration = 500, showmore = 0) => {
        if (!target.classList.contains('_slide')) {
          target.classList.add('_slide');
          target.hidden = target.hidden ? false : null;
          showmore ? target.style.removeProperty('height') : null;
          let height = target.offsetHeight;
          target.style.overflow = 'hidden';
          target.style.height = showmore ? `${showmore}px` : `0px`;
          target.style.paddingTop = 0;
          target.style.paddingBottom = 0;
          target.style.marginTop = 0;
          target.style.marginBottom = 0;
          target.offsetHeight;
          target.style.transitionProperty = "height, margin, padding";
          target.style.transitionDuration = duration + 'ms';
          target.style.height = height + 'px';
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            target.classList.remove('_slide');
            // Створюємо подію
            document.dispatchEvent(new CustomEvent("slideDownDone", {
              detail: {
                target: target
              }
            }));
          }, duration);
        }
      }
      let _slideToggle = (target, duration = 500) => {
        if (target.hidden) {
          return _slideDown(target, duration);
        } else {
          return _slideUp(target, duration);
        }
      }

      (function spollers() {
        const spollersArray = document.querySelectorAll('[data-spollers]');
        if (spollersArray.length > 0) {
          
          document.addEventListener("click", setSpollerAction);

          // Отримання звичайних слойлерів
          const spollersRegular = Array.from(spollersArray).filter(function (item, index, self) {
            return !item.dataset.spollers.split(",")[0];
          });

          // Ініціалізація звичайних слойлерів
          spollersRegular.length && initSpollers(spollersRegular);
          
          // Ініціалізація
          function initSpollers(spollersArray) {
            spollersArray.forEach(spollersBlock => {
              spollersBlock.classList.add('_spoller-init');
              initSpollerBody(spollersBlock);
            });
          }

          // Робота з контентом
          function initSpollerBody(spollersBlock, hideSpollerBody = true) {
            let spollerItems = spollersBlock.querySelectorAll('details');
            
            if (spollerItems.length) {
              spollerItems = Array.from(spollerItems).filter(item => item.closest('[data-spollers]') === spollersBlock);
              spollerItems.forEach(spollerItem => {
                let spollerTitle = spollerItem.querySelector('summary');

                if (hideSpollerBody) {
                  spollerTitle.removeAttribute('tabindex');
                  if (!spollerItem.hasAttribute('data-open')) {
                    spollerItem.open = false;
                    spollerTitle.nextElementSibling.hidden = true;
                  } else {
                    spollerTitle.classList.add('_spoller-active');
                    spollerItem.open = true;
                  }
                }
              });
            }
          }

          function setSpollerAction(e) {
            const el = e.target;
            if (el.closest('summary') && el.closest('[data-spollers]')) {
              e.preventDefault();
              if (el.closest('[data-spollers]').classList.contains('_spoller-init')) {
                const spollerTitle = el.closest('summary');
                const spollerBlock = spollerTitle.closest('details');
                const spollersBlock = spollerTitle.closest('[data-spollers]');
                const oneSpoller = spollersBlock.hasAttribute('data-one-spoller');
                const scrollSpoller = spollerBlock.hasAttribute('data-spoller-scroll');
                const spollerSpeed = spollersBlock.dataset.spollersSpeed ? parseInt(spollersBlock.dataset.spollersSpeed) : 500;
                if (!spollersBlock.querySelectorAll('._slide').length) {
                  if (oneSpoller && !spollerBlock.open) {
                    hideSpollersBody(spollersBlock);
                  }

                  !spollerBlock.open ? spollerBlock.open = true : setTimeout(() => { spollerBlock.open = false }, spollerSpeed);

                  spollerTitle.classList.toggle('_spoller-active');
                  _slideToggle(spollerTitle.nextElementSibling, spollerSpeed);

                  if (scrollSpoller && spollerTitle.classList.contains('_spoller-active')) {
                    const scrollSpollerValue = spollerBlock.dataset.spollerScroll;
                    const scrollSpollerOffset = +scrollSpollerValue ? +scrollSpollerValue : 0;
                    const scrollSpollerNoHeader = spollerBlock.hasAttribute('data-spoller-scroll-noheader') ? document.querySelector('.header').offsetHeight : 0;

                    //setTimeout(() => {
                    window.scrollTo(
                      {
                        top: spollerBlock.offsetTop - (scrollSpollerOffset + scrollSpollerNoHeader),
                        behavior: "smooth",
                      }
                    );
                    //}, spollerSpeed);
                  }
                }
              }
            }
          }
          function hideSpollersBody(spollersBlock) {
            const spollerActiveBlock = spollersBlock.querySelector('details[open]');
            if (spollerActiveBlock && !spollersBlock.querySelectorAll('._slide').length) {
              const spollerActiveTitle = spollerActiveBlock.querySelector('summary');
              const spollerSpeed = spollersBlock.dataset.spollersSpeed ? parseInt(spollersBlock.dataset.spollersSpeed) : 500;
              spollerActiveTitle.classList.remove('_spoller-active');
              _slideUp(spollerActiveTitle.nextElementSibling, spollerSpeed);
              setTimeout(() => { spollerActiveBlock.open = false }, spollerSpeed);
            }
          }
        }
      })()
    },

    copyValue() {
      const copyItems = document.querySelectorAll("[data-copy]");

      if (copyItems.length > 0) {
        copyItems.forEach((item) => {
          item.addEventListener("click", copyValue);
        });
      }
    
      function removeValues() {
        copyItems.forEach((item) => item.classList.remove("copied"));
      }
    
      function copyValue(e) {
        removeValues();
        const current = e.currentTarget;
        let trimedText;

        if (current.nodeName !== "BUTTON") {
          const copyText = current.previousElementSibling;
          trimedText = copyText.textContent;

          current.classList.add("copied");
        } else {
          trimedText = current.getAttribute('data-value');
          current.classList.add("show-tip");

          setTimeout(() => {
            current.classList.remove("show-tip");
          }, 3000)
        }
    
        navigator.clipboard
        .writeText(trimedText)
        .then(() => {
          console.log("Text copied to clipboard");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
      }
    },

    historyAnimation() {
      function historyAnimation(elements) {

        const controlLine = window.innerHeight / 3;

        window.addEventListener('scroll', ()=>{
          setTimeout(()=>{
            elements.forEach(element => {
              const top = element.getBoundingClientRect().top;
              if(top < controlLine) {
                element.classList.add('is-active')
              } else {
                element.classList.remove('is-active')
              }
            })
          }, 200)
        })
      }
      
      const elements = [...document.querySelectorAll('.js-history-item:not(:first-child)')];
  
      elements.length && historyAnimation(elements);
    },

    articleFilter() {
      let filterTypeItem = $('.types-filter__item');
      let filterParams = '';

      filterTypeItem.click(function(){
        filterTypeItem.removeClass('active');
        $(this).addClass('active');

        getFilterPosts();
      });

      const filter = $('.js-filters');
      const datepickerBtn = filter.find('.js-dp-btn');
      const datepickerInput = filter.find('.js-dp-input');
      const resetFilter = filter.find('.js-filter-reset');

      const siteLang = $('html').attr('lang');
      const calendarLang = siteLang === 'uk' ? 'uk' : 'en';

      // datepicker
      const datepicker = new Datepicker(datepickerInput[0], {
        language: calendarLang,
        autohide: true,
      });

      if (datepickerBtn.data('set-date')) {
        const specificDate = new Date(datepickerBtn.data('set-date'));
        datepicker.setDate(specificDate);
      }

      function showDatepicker() {
        datepickerInput.focus();
      }

      function removeAllParams() {
        filterTypeItem.removeClass('active');
        $('.types-filter__item[data-filter-type="all"]').addClass('active');
        datepicker.setDate(null);
        datepicker.hide();
        datepicker.show();
        datepicker.hide();
        datepickerBtn.attr('data-set-date', '');
        datepickerBtn.removeClass('active');
        getFilterPosts();
      }

      const datepickerGrid = $('.datepicker-grid');

      datepickerGrid.on('click', function(e) {
        const target = $(e.target);
        if (target.attr('data-date')) {

          const timestamp = target.attr('data-date');
          
          if (timestamp) {
            const date = new Date(parseInt(timestamp, 10));

            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();

            datepickerBtn.attr('data-set-date', year+'-'+month+'-'+day);
            datepickerBtn.addClass('active');

            getFilterPosts();
        
          }
        }
      });

      function getParameters() {
        let parameters = '';
        let reset = false;

        let filterParam = [];
        filterParam['article-type'] = [];
        filterParam['article-type'] = $('.types-filter__item.active').data('filter-type');

        filterParam['article-date'] = datepickerBtn.attr('data-set-date');

        if (filterParam['article-type'] && filterParam['article-type'] != 'all') {
          parameters += '&article-type=' + filterParam['article-type'];
          reset = true;
        }
        if (filterParam['article-date']) {
          parameters += '&article-date=' + filterParam['article-date'];
          reset = true;
        }

        if (reset) {
          resetFilter.removeClass('hide');
        } else {
          resetFilter.addClass('hide');
        }

        if (parameters.length) {
          parameters = '?'+ parameters.slice(1);
        }
        filterParam['parameters'] = parameters;

        return filterParam;
      };

      function getFilterPosts() {
        let l = (lang != 'uk') ? '/' + lang : '';
        let filterParams = getParameters();
        history.pushState('','', window.location.origin + l + '/articles/' + filterParams['parameters']);

        let data = {
          'action'    : 'filter_articles',
          'type'      : filterParams['article-type'],
          'date'      : filterParams['article-date'],
          'urlParam'  : filterParams['parameters']
        };
        console.log(data);
        $.ajax({
          url:ajaxurl,
          data:data,
          type:'POST',
          success:function(data){
            console.log(data);
            let res = JSON.parse(data);
            $('.nothing-found__text').remove();
            if (res.posts !== ''){
              $('.posts-list__inner').html(res.posts);
            } else {
              $('.posts-list__inner').html('');
              $('.posts-list__inner').after(res.notposts);
            }
            $('.pagination').remove();
            $('.posts-list__inner').after(res.pagination);
          }
        });
      };

      resetFilter.on('click', removeAllParams);
      datepickerBtn.on('click', showDatepicker);
    },

    // articleFilter() {
    //   const filter = document.querySelector('.js-filters')
    //   const datepickerBtn = filter.querySelector('.js-dp-btn');
    //   const datepickerInput = filter.querySelector('.js-dp-input');
    //   const resetFilter = filter.querySelector('.js-filter-reset');
    //   const urlParams = new URLSearchParams(window.location.search);

    //   const siteLang = document.documentElement.getAttribute('lang');
    //   const calendarLang = siteLang === 'uk' ? 'uk' : 'en';
  
    //   //datepicker
    //   const datepicker = new Datepicker(datepickerInput, {language: calendarLang});

    //   function showDatepicker() {
    //     datepickerInput.focus();
    //     datepickerBtn.classList.add('open')
    //   }

    //   function removeAllParams() {
    //     let url = new URL(window.location.href);
    //     let baseUrl = url.origin + url.pathname;

    //     window.location.href = baseUrl;
    //   }

    //   const fliterDate = sessionStorage.getItem("fliterDate");
      
    //   if (fliterDate) {
    //     const specificDate = new Date(fliterDate);
    //     datepicker.setDate(specificDate);
    //   } else {
    //     const initialDate = new Date();
    //     datepicker.setDate(initialDate);
    //   }
      
    //   const datepickerGrid =  document.querySelector('.datepicker-grid');

    //   datepickerGrid.addEventListener('click', (e) => {
    //     if (e.target.getAttribute('data-date')) {

    //       const timestamp = e.target.getAttribute('data-date');
      
    //       if (timestamp) {
    //         const date = new Date(parseInt(timestamp, 10));
      
    //         const year = date.getFullYear();
    //         const month = date.getMonth() + 1;
    //         const day = date.getDate();

    //         const originUrl = window.location.origin;
    //         const queryString = `/articles/?year=${year}&month=${month}&day=${day}`;

    //         sessionStorage.setItem('fliterDate', `${year}-${month}-${day}`)
        
    //         window.location.href = originUrl + queryString;
    //       }
    //     }
    //   });

    //   //events
    //   resetFilter.addEventListener('click', removeAllParams);
    //   datepickerBtn.addEventListener('click', showDatepicker);

    //   if (urlParams.get('day')) resetFilter.style.display = "flex";
    // },

    scrollbarCheck() {
      function hasScrollBar(element) {
        return element.prop('scrollWidth') > element.width();
      }

      function checkScrollBars() {
        $('.filters-has-scrollbar-list').each(function() {
            var element = $(this);
            var parentElement = element.closest('.filters-has-scrollbar');
            if (hasScrollBar(element)) {
                parentElement.attr('data-has-scrollbar', 'true');
            } else {
                parentElement.attr('data-has-scrollbar', 'false');
            }
        });
      }

      checkScrollBars();

      $(window).resize(function() {
          checkScrollBars();
      });
    },

    adviceCentres() {
      const siteLang = document.documentElement.getAttribute('lang');
      const regionTooltip = siteLang === 'uk' ? 'data-region-title' : 'data-region';
  
      const mapRegions = document.querySelectorAll('#centres-map g');

      mapRegions.forEach(region => {

        const regionAttr = region.getAttribute(regionTooltip)

        if (document.querySelector(`.location-centres [data-region-title="${regionAttr}"]`)) {
          region.classList.add('is-presented');
        }

        // Toolip
        if (document.body.clientWidth > 767) {
          region.addEventListener('mouseover', () => {
  
            const tooltip = document.createElement('div');
            tooltip.classList.add('tooltip');
            tooltip.textContent = region.getAttribute(`${regionTooltip}`);
  
            document.body.appendChild(tooltip);
  
            const updateTooltipPosition = (e) => {
              tooltip.style.left = `${e.pageX}px`;
              tooltip.style.top = `${e.pageY - tooltip.offsetHeight}px`;
            };
  
            updateTooltipPosition(event);
  
            region.addEventListener('mousemove', updateTooltipPosition);
  
            region.addEventListener('mouseout', () => {
              tooltip.remove();
              region.removeEventListener('mousemove', updateTooltipPosition);
            }, { once: true });
          });
        }

        // Scroll
        region.addEventListener('click', () => {
          const sectionAtribute = region.getAttribute(regionTooltip);
          const section = document.querySelector(`.location-centres [data-region-title="${sectionAtribute}"]`);
          
          section?.scrollIntoView({ behavior: "smooth", block: "start"});
        });
      });
    },

    scrollTo() {
      if (window.location.hash) {
        setTimeout(() => {
          const element = document.querySelector(window.location.hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    },

    scrollObserver() {
      const scrollbars = document.querySelectorAll('._scrollbar'); 

      function checkForScrollbar(scrollbar) {
        let scrollBarWidth = scrollbar.querySelector('ul').scrollWidth;
    
        if (scrollbar.scrollWidth < scrollBarWidth) {
          scrollbar.classList.add('active');
        } else {
          scrollbar.classList.remove('active');
        }
      }
    
      function handleScrollbars() {
        scrollbars.forEach(scrollbar => {
          checkForScrollbar(scrollbar);
    
          window.addEventListener('resize', () => checkForScrollbar(scrollbar));
    
          const observer = new MutationObserver(() => checkForScrollbar(scrollbar));
          observer.observe(scrollbar, { childList: true, subtree: true });
        });
      }
    
      window.addEventListener('load', handleScrollbars);
    }
	};
	$(document).ready(function () {
		Scripts.header();
    Scripts.search();
		Scripts.copyValue();
		Scripts.scrollTo();
		Scripts.scrollObserver();

    if ($(".page-template-tmpl-about").length || 
        $(".page-template-tmpl-advice-centres").length) {
      Scripts.spollers();
    }

    if ($(".home").length) {
      Scripts.home();
    }

    if ($(".page-template-tmpl-history").length) {
      Scripts.historyAnimation();
    }

    if ($(".page-template-tmpl-advice-centres").length) {
      Scripts.adviceCentres();
    }

    if ($(".post-type-archive-articles").length) {
      Scripts.articleFilter();
      Scripts.scrollbarCheck();
    }
	});
  // $(window).resize(function() {
  //    Scripts.header();
  // });
});